import { FormControlLabel, Grid, Radio, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import FormikRadio from "../../../../components/commons/formik/FormikRadio";
import FormikTextField from "../../../../components/commons/formik/FormikTextField";
import { getActividadesEmpleador } from "../../../../redux/actions/afiliaciones";
import { decretoToEnum, tipoDeActividadPorDecreto } from "../../../commons/enums/RgrlEnums";
import FormikActions from "../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../commons/formik/FormikAutocomplete";
import CharactersCounterLabel from "../../../commons/labels/CharactersCounterLabel";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import { StyledRgrl } from "../../../styled/Prevencion";
import { decretosFormValidation } from "../validation/formValidation";

const DecretoForm = ({
  handleSubmit,
  handleDecretoChange,
  handleActividadChange,
  data,
  formModel,
  requerirActividad,
}) => {
  const dispatch = useDispatch();
  const actividades = useSelector((state) => state.afiliaciones.actividadesEmpleador.data);
  const searchedRgrl = useSelector((state) => state.rgrl.searchedRgrl);

  return (
    <>
      <FechaPresentacionLabel />
      <Formik
        initialValues={{
          ...formModel,
        }}
        enableReinitialize={true}
        onSubmit={handleSubmit}
        validationSchema={() => decretosFormValidation(requerirActividad)}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <StyledRgrl.FlexDirectionColumn container spacing={3}>
              <Grid item container xs={12}>
                <StyledRgrl.PaddingContainer item xs={6}>
                  {requerirActividad
                    ?
                    <>
                      <FormikAutocomplete
                        name="idActividad"
                        label="Actividad*"
                        options={actividades}
                        renderOption={(option) => option.nombre}
                        filterOptions={(option) => option.nombre}
                        fullWidth
                        getOptions={() => dispatch(getActividadesEmpleador())}
                        callBack={(v) => {
                          handleActividadChange(v?.id);
                          setFieldValue('idActividad', formModel.idActividad);
                        }}

                      />
                    </>
                    : <Typography>Seleccionar el Decreto</Typography>
                  }
                  <StyledRgrl.RadioContainer>
                    {
                      data?.opciones ?
                        (
                          data.opciones.map((decreto, index) => (
                            <FormikRadio groupProps={{ style: { alignItems: "baseline" } }} name="decretos" row key={index}>
                              <StyledRgrl.FormikRadio>
                                <FormControlLabel
                                  name="nombre"
                                  control={
                                    <Radio
                                      onChange={() => {
                                        handleDecretoChange(decreto);
                                      }}
                                      disabled
                                      checked={decreto.id === formModel.id}
                                    />
                                  }
                                  label={`Decreto ${decreto.nombre}`}
                                  labelPlacement="end"
                                />
                              </StyledRgrl.FormikRadio>
                              <StyledRgrl.RadioButtonExtraLabel>
                                (Actividad {tipoDeActividadPorDecreto[decretoToEnum(decreto.nombre)]})
                              </StyledRgrl.RadioButtonExtraLabel>
                            </FormikRadio>
                          ))
                        )
                        :
                        null
                    }
                  </StyledRgrl.RadioContainer>
                </StyledRgrl.PaddingContainer>
                <StyledRgrl.PaddingContainer item xs={6}>
                  <Typography style={{ textAlign: "center" }}>
                    Datos del Establecimiento
                  </Typography>
                  <StyledRgrl.TextInputGroupContainer>
                    <StyledRgrl.FormikInput>
                      <FormikTextField
                        fullWidth={true}
                        name="totalTrabajadoresEstablecimientos"
                        label="Total Trabajadores del Establecimiento *"
                      />
                    </StyledRgrl.FormikInput>
                    <StyledRgrl.FormikInput>
                      <FormikTextField
                        fullWidth={true}
                        name="totalEstablecimientos"
                        label="Total de Establecimientos *"
                      />
                    </StyledRgrl.FormikInput>
                    <StyledRgrl.FormikInput>
                      <FormikTextField
                        fullWidth={true}
                        name="superficie"
                        label="Superficie M2 *"
                      />
                    </StyledRgrl.FormikInput>
                  </StyledRgrl.TextInputGroupContainer>
                </StyledRgrl.PaddingContainer>
              </Grid>
              <Grid item xs={12}>
                <StyledRgrl.PaddingContainer>
                  <FormikTextField
                    fullWidth={true}
                    name="observaciones"
                    label="Observaciones"
                    type="text"
                    variant="outlined"
                    multiline
                    maxRows={15}
                    minRows={2}
                  />
                  <CharactersCounterLabel
                    value={values.observaciones}
                    maxCharacters={100}
                  />
                </StyledRgrl.PaddingContainer>
              </Grid>
            </StyledRgrl.FlexDirectionColumn>
            <StyledRgrl.ButtonContainer>
              <FormikActions
                submit="Siguiente"
                disabled={(requerirActividad && !values.idActividad) || !values.id}
              />
            </StyledRgrl.ButtonContainer>
          </Form>
        )}
      </Formik >
    </>
  );
};

export default DecretoForm;
